module.exports = __webpack_public_path__ + "img/ep-F.1f9ce98f.jpg";